// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__Ks6gr","modalFooterButton":"ModalNotes_modalFooterButton__3G9Rt"};